if (!customElements.get('ly-main-cart-items-content-form-item-set-expandable-wrapper')) {
    customElements.define('ly-main-cart-items-content-form-item-set-expandable-wrapper', class extends HTMLElement {
        connectedCallback() {
            this.checkbox = this.querySelector('input')

            this.handleChange()
            this.checkbox.addEventListener('change', this.handleChange)
        }

        disconnectedCallback() {
            this.checkbox.removeEventListener('change', this.handleChange)
        }

        handleChange = () => {
            this.classList.toggle('is-open', this.checkbox.checked)
        }
    })
}